// serviceWorkerRegistration.js (or whatever its name is)
export function register() {
  // ✅ Disable SW to avoid caching/auth bugs
  unregister();
}

export async function unregister() {
  if (!("serviceWorker" in navigator)) return;

  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      await reg.unregister();
    }

    // ✅ Also clear SW caches (important)
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }

    console.log("SW unregistered and caches cleared");
  } catch (err) {
    console.error("SW unregister failed:", err);
  }
}